import type { ISerialize } from '@/objects/ISerialize';
import type { SearchType } from './../enums/SearchType';

export class SearchRequest implements ISerialize {
    public Maxitems: number;

    public Query: string | null;

    public SearchType: SearchType;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Maxitems?: number; Query?: string | null; SearchType?: SearchType }) {
        this.Maxitems = values.Maxitems ?? 0;

        this.Query = values.Query ?? null;

        this.SearchType = values.SearchType ?? 'StartsWith';
    }

    public serialize(): string {
        return (
            '{' +
            `"Maxitems": ${JSON.stringify(this.Maxitems)}` +
            ',' +
            `"Query": ${JSON.stringify(this.Query)}` +
            ',' +
            `"SearchType": ${this.SearchType == 'StartsWith' ? 0 : this.SearchType == 'EndsWith' ? 1 : this.SearchType == 'ExactWord' ? 2 : this.SearchType == 'Contains' ? 3 : this.SearchType == 'ContainsAll' ? 4 : 0}` +
            '}'
        );
    }

    /**
     * Creates an instance of SearchRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Maxitems?: number; Query?: string | null; SearchType?: SearchType }): SearchRequest {
        return new SearchRequest(values);
    }

    public static _FromServerJson(json: any): SearchRequest {
        return new SearchRequest({
            Maxitems: json.Maxitems,
            Query: json.Query ?? '',
            SearchType:
                json.SearchType == 0
                    ? 'StartsWith'
                    : json.SearchType == 1
                      ? 'EndsWith'
                      : json.SearchType == 2
                        ? 'ExactWord'
                        : json.SearchType == 3
                          ? 'Contains'
                          : json.SearchType == 4
                            ? 'ContainsAll'
                            : 'StartsWith',
        });
    }

    /**
     * Creates an instance of SearchRequest from another instance of SearchRequest.
     * @param other The SearchRequest you want to clone
     * @returns A cloned SearchRequest
     */
    public static FromOther(other: SearchRequest): SearchRequest {
        return SearchRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SearchRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SearchRequest';
}
